import { visitServiceApi } from "../../app/visitServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { GetQueryArgsType } from "../../types";
import {
  GetTrackingByDateRangeParams,
  GetTrackingByDateRangeResponseType,
  TrackingEmployeeListResponseType,
  TrackingEmployeeParams,
  TrackingSettingsLogsResponseType,
  TrackingSettingsResponseType,
} from "../../types/tracking";

export const trackingApi = visitServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    updateVisitSetting: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateVisitSetting}/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getTrackingSetting: builder.query<
      TrackingSettingsResponseType,
      number | null
    >({
      query: (id) => ({
        url: `${API_URL.getTrackingSetting}/${id}`,
      }),
      providesTags: ["GetTrackingSetting"],
    }),
    updateTrackingSetting: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateTrackingSetting}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["GetTrackingSetting"],
    }),
    getTrackingSettingLogs: builder.query<
      TrackingSettingsLogsResponseType,
      number | null
    >({
      query: (id) => ({
        url: `${API_URL.getTrackingSettingLogs}/${id}`,
      }),
    }),
    getTrackingEmployeeList: builder.query<
      TrackingEmployeeListResponseType,
      GetQueryArgsType<TrackingEmployeeParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTrackingEmployeeList,
        ...queryArgs,
      }),
      providesTags: ["GetTrackingEmployeeList"],
    }),
    getTrackingDataByDateRange: builder.query<
      GetTrackingByDateRangeResponseType,
      GetQueryArgsType<GetTrackingByDateRangeParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTrackingDataByDateRange,
        ...queryArgs,
      }),
    }),
    addEmployeeLiveTrackingSetting: builder.mutation({
      query: (data) => ({
        url: API_URL.addEmployeeLiveTrackingSetting,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["GetTrackingEmployeeList"],
    }),
    downloadTrackingHistory: builder.query<
      void,
      GetQueryArgsType<GetTrackingByDateRangeParams>
    >({
      query: (queryArgs) => ({
        url: `${API_URL.downloadTrackingHistory}`,
        responseHandler: async (response: any) => {
          const blob = await response.blob(); // Convert response to blob
          return window.URL.createObjectURL(blob); // Create object URL
        },
        cache: "no-cache",
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useUpdateVisitSettingMutation,
  useGetTrackingSettingQuery,
  useUpdateTrackingSettingMutation,
  useGetTrackingSettingLogsQuery,
  useGetTrackingEmployeeListQuery,
  useAddEmployeeLiveTrackingSettingMutation,
  useGetTrackingDataByDateRangeQuery,
  useLazyDownloadTrackingHistoryQuery,
} = trackingApi;
